import React from 'react'
import {Route, IndexRedirect} from 'react-router'

import LandingsInsightView from 'views/LandingsInsightView'
import LandingsInsightViewMenu from 'views/LandingsInsightView/menu'
import FunnelView from 'views/FunnelView'

export default trackRoute => {
  return (
    <Route path='conversion' title='Conversion'>
      <Route
        path='landings'
        title='Landing Pages Insights'
        components={{main: LandingsInsightView, menu: LandingsInsightViewMenu}}
        onEnter={trackRoute('landing-pages')}
      />
      <Route
        path='funnels'
        title='Funnels Insights'
        components={{main: FunnelView, menu: LandingsInsightViewMenu}}
        onEnter={trackRoute('funnels')}
      />
      <IndexRedirect to='/conversion/funnels' />
    </Route>
  )
}



// WEBPACK FOOTER //
// ./client/routes/conversion.js